export default "__VITE_ASSET__BJZL09nx__"